import { AuxBadge } from "@blk/aladdin-react-components-es";
import { AuxBadgeTypeEnum, AuxBadgeStyleEnum } from "@blk/aladdin-web-components";
import React from "react";
import "./principleViolationTypeCell.scss";
import { ViolationType as ViolationStatus } from "common/un-principles-helper";
const getViolationStatusIcon = (violationStatus) => {
    switch (violationStatus) {
        case ViolationStatus.NoViolation:
            return React.createElement(AuxBadge, { type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.SUCCESS });
        case ViolationStatus.Potential:
            return React.createElement(AuxBadge, { type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.WARNING });
        case ViolationStatus.Violation:
            return React.createElement(AuxBadge, { type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.ALERT });
        default:
            return "";
    }
};
export const PrincipleViolationTypeCell = ({ value }) => {
    const violationStatus = value;
    const icon = getViolationStatusIcon(violationStatus);
    return React.createElement("td", { className: "principle-violation-type-cell" }, icon);
};
